import "../../components/Archetype/Archetype.css"
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IMG_URL } from '../../config';

function Archetype({ data }) {

    // const ArcheData = data?.length > 0 ? data[0] : null;

    const ArcheData = data;

    return (
        <div className="arch-section">

            <div className="container">

                {ArcheData &&

                    <div className="row arch-title-row" >
                        <h3 className="arch-title">{ArcheData?.Archetypetitle}</h3>
                    <div className="arch-button">
                    <a href="/64Archetypes">
                        <button>{ArcheData?.see_all_archetype} </button>
                    </a>
                </div>
                    </div>
                }

                {/* <div className="arch-button">
                    <a href="/classifications">
                        <button>See All 64 Archetypes</button>
                    </a>
                </div> */}


                <div className="row gy-4">


                    {ArcheData &&

                        <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                            <div className="arch-cards">

                                <div className="arch-img-div">
                                    <img loading="lazy" decoding="async" src={`${IMG_URL}/d0/${ArcheData?.visionaryimage1}`} alt={ArcheData?.visionaryimage1_alt} />

                                </div>

                                <div className="arch-content-div">

                                    <h5>{ArcheData.visionarytitle1}</h5>

                                    <p>{ArcheData.visionarysubtitle1}</p>

                                </div>


                                <a className="arch-btn" href={ArcheData.visionarybuttonlink1}>

                                    {/* <a className="arch-btn" href={`arche/${ArcheData.slug}`}> */}

                                    <span className='arch-btn-sp'>
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                </a>

                            </div>
                        </div>
                    }

                    {ArcheData &&

                        <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                            <div className="arch-cards">

                                <div className="arch-img-div">
                                    <img loading="lazy" decoding="async" src={`${IMG_URL}/d0/${ArcheData?.visionaryimage2}`} alt={ArcheData?.visionaryimage2_alt} />
                                </div>

                                <div className="arch-content-div">

                                    <h5>{ArcheData.visionarytitle2}</h5>

                                    <p>{ArcheData.visionarysubtitle2}.</p>

                                </div>


                                <a className="arch-btn" href={ArcheData.visionarybuttonlink2}>

                                    <span className='arch-btn-sp'>
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                </a>

                            </div>
                        </div>
                    }
                    {ArcheData &&

                        <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                            <div className="arch-cards">

                                <div className="arch-img-div">
                                    <img loading="lazy" decoding="async" src={`${IMG_URL}/d0/${ArcheData?.visionaryimage3}`} alt={ArcheData?.visionaryimage3_alt} />
                                </div>

                                <div className="arch-content-div">

                                    <h5>{ArcheData.visionarytitle3}</h5>

                                    <p>{ArcheData.visionarysubtitle3}.</p>

                                </div>


                                <a className="arch-btn" href={ArcheData.visionarybuttonlink3}>

                                    <span className='arch-btn-sp'>
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                </a>

                            </div>
                        </div>
                    }

                    {ArcheData &&

                        <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                            <div className="arch-cards">

                                <div className="arch-img-div">
                                    <img loading="lazy" decoding="async" src={`${IMG_URL}/d0/${ArcheData?.visionaryimage4}`} alt={ArcheData?.visionaryimage4_alt} />
                                </div>

                                <div className="arch-content-div">

                                    <h5>{ArcheData.visionarytitle4}</h5>

                                    <p>{ArcheData.visionarysubtitle4}.</p>

                                </div>


                                <a className="arch-btn" href={ArcheData.visionarybuttonlink4}>

                                    <span className='arch-btn-sp'>
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                </a>

                            </div>
                        </div>
                    }


                </div>

                <div className="arch-bottom-btn">

                    <p dangerouslySetInnerHTML={{ __html: ArcheData?.discover_personality }}></p>

                    <a
                        className="home-slider-sun-box-a"
                        href="/test/free-starter-quiz"
                        rel="noopener noreferrer"
                    >
                        <span className="home-slider-sun-box-a-text"> {ArcheData?.discover_button}</span>
                        <span className="home-slider-sun-box-a-icon">
                            <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                    </a>
                </div>


            </div>



        </div>
    )
}

export default Archetype